import * as React from "react";
import { Props } from "../../types/global";
import { MyAccountService } from "./myaccount-service";
import t from "../i18n";
import { StoredCreditCard } from "../types";
import { Loading } from "../common/Loading";
import StoredCardBlock from "./StoredCardBlock";

declare type CardState = {
    storedCards?: StoredCreditCard[],
}

export default class StoredCardsList extends React.Component<Props, CardState> {
    readonly state: CardState = {};
    componentDidMount() {
        MyAccountService.fetchStoredCards().then(result =>
            this.setState({ storedCards: result.payLoad || [] })
        );
    }
    render() {
        if (!this.state.storedCards) return <Loading />;

        const recurringProfileCards = this.state.storedCards.filter(card => card.isUsedForRecurringProfile === true);

        return <div className="container-fluid" style={pageWidth}>
            {this.renderStoredCard(this.state.storedCards)}
            {recurringProfileCards && this.renderRecurringCards(recurringProfileCards)}
        </div>
    }

    renderStoredCard = (cards: StoredCreditCard[]) => {
        return <div>
            <div className="form-group form-title">
                <h2>{t.menu("stored-cards")}</h2>
            </div>
            <div className="row">
                {cards.map(card => card.isUsedForRecurringProfile === false ? <StoredCardBlock key={card.creditCardId} creditCard={card} /> : <div />)}
            </div>
        </div>
    }

    renderRecurringCards = (cards: StoredCreditCard[]) => {
        return <div>
            <hr/>
            <div className="row">
                {cards.map(card => <StoredCardBlock key={card.creditCardId} creditCard={card} />)}
            </div>
            <h6>{t.menu("note")}</h6>
        </div>
    }


}
const pageWidth: React.CSSProperties = {
    maxWidth: 768,
    width: "100%",
}